<template>
  <span>
    <span class="relative">
      <span v-if="!hideText">{{lifeArea}}</span>
      <vx-tooltip v-if="showIcon" :text="lifeArea" delay="0.5s" class="text-center">
          <feather-icon  :icon="icon" :class="sizeClass" class="mr-1" :style="style" />
      </vx-tooltip>
    </span>
  </span>
</template>
<script>
import LifeAreas from '@/models/LifeAreas'

export default {
  components: {
  },
  props: ['lifeArea', 'showIcon', 'hideText', 'size'],
  data () {
    return {
    }
  },
  computed: {
    icon () {
      return LifeAreas[this.lifeArea]['icon']
    },
    sizeClass () {
      return this.size == 'small' ? 'w-3' : 'w-5'
    },
    style () {
      return this.size == 'small' ? '' : 'top: 5px'
    }
  },
  methods: {
  },
}
</script>

<style lang="scss">

.saved_review {
  .vx-card__header {
    padding: 0.6rem
  }
}

</style>
